const brandPageData = {
  samsung: {
    brand: "Samsung",
    slug: "samsung-appliance-repair-bangalore",
    title: "Samsung Appliance Repair Service Bangalore",
    description:
      "Trusted Samsung appliance services in Bangalore for refrigerators, washing machines, microwaves, and more with quick doorstep support.",
    keywords:
      "samsung appliance repair bangalore, samsung service bangalore, appliance repair bangalore",
    heroTitle: "Samsung Appliance Service in Bangalore",
    intro:
      "Customer Supports 24x7 provides trusted Samsung appliance repair services in Bangalore with experienced technicians and convenient doorstep support.",
    details:
      "We handle Samsung washing machines, refrigerators, microwaves, and other home appliances with quick diagnosis, reliable repairs, and service support across Bangalore.",
    services: [
      "Samsung washing machine repair and maintenance",
      "Samsung refrigerator cooling and gas charging support",
      "Samsung microwave inspection and repair",
      "Samsung AC and home appliance service assistance",
    ],
    issues: [
      "Appliance not starting",
      "Cooling, heating, or drainage problems",
      "Noise, vibration, and performance issues",
      "Electrical and control panel faults",
    ],
  },
  ifb: {
    brand: "IFB",
    slug: "ifb-appliance-repair-bangalore",
    title: "IFB Appliance Repair Service Bangalore",
    description:
      "Fast and reliable IFB appliance repair available in Bangalore with expert technical support and genuine spare parts.",
    keywords:
      "ifb appliance repair bangalore, ifb service bangalore, appliance repair bangalore",
    heroTitle: "IFB Appliance Service in Bangalore",
    intro:
      "Customer Supports 24x7 offers fast and reliable IFB appliance repair in Bangalore for homes that need prompt and professional service.",
    details:
      "Our technicians service IFB washing machines, microwaves, dishwashers, and other appliances using careful fault diagnosis and dependable repair methods.",
    services: [
      "IFB washing machine repair and installation support",
      "IFB microwave and dishwasher troubleshooting",
      "Replacement of damaged parts with suitable spares",
      "Preventive maintenance for better appliance performance",
    ],
    issues: [
      "Appliance not powering on",
      "Drum, drainage, and spin issues",
      "Heating and program control faults",
      "Leakage and unusual sound complaints",
    ],
  },
  whirlpool: {
    brand: "Whirlpool",
    slug: "whirlpool-appliance-repair-bangalore",
    title: "Whirlpool Appliance Repair Bangalore",
    description:
      "Expert Whirlpool appliance repair service in Bangalore with quick response and doorstep service for all appliance models.",
    keywords:
      "whirlpool appliance repair bangalore, whirlpool service bangalore, appliance repair bangalore",
    heroTitle: "Whirlpool Appliance Service in Bangalore",
    intro:
      "Customer Supports 24x7 delivers expert Whirlpool appliance repair in Bangalore with quick response times and doorstep support.",
    details:
      "We repair Whirlpool washing machines, refrigerators, microwaves, and other home appliances with practical solutions for common and advanced faults.",
    services: [
      "Whirlpool washing machine repair service",
      "Whirlpool refrigerator and cooling system support",
      "Whirlpool microwave and appliance diagnostics",
      "Routine servicing for improved appliance life",
    ],
    issues: [
      "Cooling and compressor performance problems",
      "Water leakage and drainage faults",
      "Machine not spinning or completing cycles",
      "Buttons, panels, and sensor issues",
    ],
  },
  bosch: {
    brand: "Bosch",
    slug: "bosch-appliance-repair-bangalore",
    title: "Bosch Appliance Repair Service Bangalore",
    description:
      "Get professional Bosch appliance repair service in Bangalore for all home appliances with doorstep solutions and trained technicians.",
    keywords:
      "bosch appliance repair bangalore, bosch service center bangalore, appliance repair bangalore",
    heroTitle: "Bosch Appliance Service in Bangalore",
    intro:
      "Customer Supports 24x7 provides professional Bosch appliance repair service in Bangalore with trained technicians and doorstep assistance.",
    details:
      "We support Bosch washing machines, dishwashers, refrigerators, and other home appliances with focused troubleshooting and timely repairs.",
    services: [
      "Bosch washing machine and dishwasher support",
      "Bosch refrigerator and appliance repair",
      "Inspection of electrical and mechanical faults",
      "Maintenance service for smooth appliance performance",
    ],
    issues: [
      "Machine not responding or stopping mid-cycle",
      "Water flow, leakage, and drainage issues",
      "Cooling and temperature problems",
      "Error codes and control board faults",
    ],
  },
};

export const getBrandPageData = (brandKey) => brandPageData[brandKey];

export default brandPageData;
